/* eslint-disable max-len */
import { orderCart } from './order/main'
import { rebillyProcessOrder } from './rebilly_element'
import { defaultDomains, defaultSecondLevelDomains, defaultTopLevelDomains } from './vendor/mailCheck/domains'
import { Mailcheck } from './vendor/mailCheck/main'
import $ from 'jquery'

globalThis.processForm = function () {
  return { ...getPurchaseForm(), ...getContactForm() }
}

export type FormPurchaseProductType = {
  id: string
  price_id?: number
  quantity: number
}

export type FormPurchaseType = {
  purchase: {
    product_variants: FormPurchaseProductType[]
    coupon_codes: string[]
    rebilly_token?: string
  }
}

export function restoreButtonState(): void {
  $('.elBTN a[href="#submit-form"]').each(function () {
    const $this = $(this)
    const previousHTML = $this.attr('data-before-submit')
    if (previousHTML) {
      $this.html(previousHTML).removeClass('cf-submitting-page')
      $this.removeAttr('data-before-submit')
    }
  })
}

export function submitPage(): void {
  const data = globalThis.processForm()
  $('#cfAR .purchaseInput').remove()

  // TODO: it would be nice to post this in JSON instead of using #cfAR submit
  // problem here is that on redirect, rails returns the page to redirect to, and
  // not the URL of the page in that case.
  data.purchase.product_variants.forEach((pv) => {
    $('#cfAR').append(
      `<input type="text" class="purchaseInput" name="purchase[product_variants][][id]" value="${pv.id}" />`
    )
    $('#cfAR').append(
      `<input type="number" class="purchaseInput" \
name="purchase[product_variants][][quantity]" value="${pv.quantity}"/>`
    )
    $('#cfAR').append(
      `<input type="number" class="purchaseInput" name="purchase[product_variants][][price_id]" value="${pv.price_id}" />`
    )
  })
  data.purchase.coupon_codes.forEach((couponCode: string) => {
    $('#cfAR').append(
      `<input type="text" class="purchaseInput" name="purchase[coupon_codes][]" value="${couponCode}" />`
    )
  })

  clearBlankInputFields()
  $('#cfAR').submit()

  // type: 'POST',
  // url: window.location.toString(),
  // contentType: 'application/json',
  // dataType: 'json',
  // data: JSON.stringify(data),
  // success: function (data) {
  //   debugger
  // },
  // error: function (data) {
  //   debugger
  // },
  // })
}

function clearBlankInputFields(): void {
  $('#cfAR')
    .find('input,select,textarea')
    .each((index: number, input: HTMLInputElement) => {
      if (input.value == '') {
        input.remove()
      }
    })
}

function getPurchaseForm(): FormPurchaseType {
  const products = orderCart?.productVariants
  const formPurchaseProductVariants = products?.map((product) => {
    return {
      id: product.id,
      price_id: product.priceId,
      quantity: product.quantity,
    }
  })
  const rebillyToken = $('#cfAR input[data-rebilly="token"]').val()

  return {
    purchase: {
      product_variants: formPurchaseProductVariants,
      rebilly_token: rebillyToken as string,
      coupon_codes: [orderCart?.couponCode].filter(Boolean),
    },
  }
}

// NOTE: This method changes #cfAR according to page content input elements,
// and it also returns an object with all contact attributes (based on legacy code)
function getContactForm() {
  const data = { contact: {} }
  $('.elInput, .elSelect').each(function () {
    const $this = $(this)
    let name = $this.attr('data-custom-type') || $this.attr('name')
    if (name == '' || name == 'not-set') return

    // TODO: This ia n FHL workaround for submitting country and state as
    // shipping country and state.
    if (['country', 'state'].includes(name)) {
      name = 'shipping_' + name
    }

    const value = $this.val()
    if (value) {
      data.contact[name] = value
    }

    const $contactInput = $('#cf_contact_' + name)
    // custom type
    if ($contactInput.length == 0) {
      let customType = name.toLowerCase()

      // If you type 'Make of Vehicle' in custom field name,
      //it was passed as 'make_of vehicle' param and we're failing.
      // Yep, we're explicit that "Custom Type accepts letters and numbers only.",
      // but customers do not care, so it's easier just to fix that.
      customType = customType.replace(/\s+/g, '_')
      $('#cf_contact_' + customType).remove()

      const input = <HTMLInputElement>document.createElement('INPUT')
      input.id = 'cf_contact_' + customType
      input.name = customType
      input.setAttribute('value', value as string)
      input.setAttribute('data-cf-form-field', customType)
      input.setAttribute('data-param', customType)
      input.setAttribute('data-storage', 'false')
      $('#cfAR').append(input)
    } else {
      $contactInput.val(value) //.attr('name', name);
    }
  })
  return data
}

function validateEmail(email) {
  email = $.trim(email)
  const re = /^(([^<>()[\]\\.,;:#`%\s@"]+(\.[^<>()[\]\\.,;:#`%\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return re.test(email)
}

export function checkValidInputs(): boolean {
  const popupVisibleCheck = $('.modal-wrapper').is(':visible')
  let fail = false
  let elementPathSelector
  if (popupVisibleCheck == true) {
    // check only in the pop up
    elementPathSelector = '#modalPopup .elInput.required1, #modalPopup .elSelect.required1'
  } else {
    // check all that are visible (on page)
    elementPathSelector = '.elInput.required1, .elSelect.required1'
  }
  $(elementPathSelector).each(function () {
    const thisInput = $(this)
    const visible = $(this).is(':visible')

    if (visible) {
      if (thisInput.val() == '') {
        fail = true
        thisInput.css('border-color', '#B91517')
        thisInput.css('border-width', '3px')
      } else {
        if (thisInput.attr('name') == 'email') {
          const email = thisInput.val()
          if (validateEmail(email)) {
            thisInput.css('border-color', '#4a8920')
            thisInput.css('border-width', '3px')
          } else {
            fail = true
            thisInput.css('border-color', '#B91517')
            thisInput.css('border-width', '3px')
          }
        } else {
          thisInput.css('border-color', '#4a8920')
          thisInput.css('border-width', '3px')
        }
      }
    }
  })
  return fail == false
}

function mailCheck() {
  const inputsSelector = Array.from(document.getElementsByName('email'))

  inputsSelector.forEach((input, index) => {
    const mailCheckNode = document.createElement('div')
    mailCheckNode.classList.add('mailcheck')
    mailCheckNode.classList.add(`index${index}`)
    input.parentElement.appendChild(mailCheckNode)
    input.addEventListener('blur', function (this: HTMLInputElement) {
      Mailcheck.run({
        email: this.value,
        domains: defaultDomains,
        secondLevelDomains: defaultSecondLevelDomains, // optional
        topLevelDomains: defaultTopLevelDomains, // optional
        suggested: function (suggestion) {
          mailCheckNode.innerHTML = `<span>Did you mean <b>${suggestion.full}?</b></span>`
        },
        empty: function () {
          mailCheckNode.innerHTML = ''
        },
      })
    })
  })
}

window.addEventListener('load', function () {
  mailCheck()
  $(document).on('click', '[href="#submit-form"],[data-linkable-element-link="#submit-form"]', function () {
    let redirectOverride
    const $button = $(this)
    if ($button.parents('.elBTN').length) {
      $button.attr('data-before-submit', $button.html())
      $button.html('Submitting...').addClass('cf-submitting-page')
      redirectOverride = $button.attr('data-on-submit-go-to')
    }

    if (redirectOverride) {
      $('#cfAR').append(`<input type="text" class="redirectParams" name="redirect_to" value="${redirectOverride}" />`)
    } else {
      $('#cfAR .redirectParams').remove()
    }

    const $rebillySubmit = $('.rebilly-submit')
    const $rebillyForm = $('.elRebilly')
    if ($rebillySubmit.length) {
      $rebillySubmit.trigger('click')
      return
    } else if ($rebillyForm.length) {
      rebillyProcessOrder()
      return
    } else if (!checkValidInputs()) {
      restoreButtonState()
      return
    }
    submitPage()
  })
})
